module.exports = __webpack_public_path__ + "img/IMG_0740.bddf442b.jpg";